<template>
  <div class="bg-blue-500 text-white bg-center bg-no-repeat bg-cover" :style="{backgroundImage: `url('${currentLine.image}')`}">
    <div class="max-w-4xl mx-auto">
      <div class="flex flex-col md:flex-row-reverse">
        <div class="w-full md:w-1/3 leading-none text-lg md:text-xl pt-4 md:pt-8">
          <p
            class="py-2 cursor-pointer"
            @click="selectLine(i)"
            :class="currentLineIndex == i ? 'font-bold' : 'hover:font-bold'"
            :key="`line-link-${i}`"
            v-for="(line, i) in lines">{{ line.name }}</p>
        </div>
        <div class="w-full md:w-2/3">
          <div class="py-40 hidden md:block"></div>
          <div class="p-4 md:p-8" style="background-color: rgba(0,193,222,0.5)" v-if="currentLineIndex != null">
            <p class="text-xl md:text-2xl mb-2">{{ currentLine.name }}</p>
            <div class="mb-4 text-justify page-content" v-html="currentLine.short_description"></div>
            <p class="text-ceter"><a :href="currentLine.link" class="link-square">{{ trans('common.explore') }}</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'business-lines',
  props: {
    lines: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      currentLine: {
        image: ''
      },
      currentLineIndex: null,
    }
  },
  methods: {
    selectLine(index) {
      this.currentLineIndex = index;
      this.currentLine = this.lines[index];
    }
  },
  mounted() {
    if (this.lines.length > 0) {
      this.selectLine(0);
    }
  }
}
</script>